<ng-select
  class="dropdown-right"
  [items]="[]"
  [ngModel]="currentPharmacy"
  (change)="onChange($event)"
  [typeahead]="search"
  bindLabel="name"
  placeholder="All Pharmacies"
></ng-select>
